import { PhoneCountry } from "types/PhoneCountries";

export const getCountryByPhoneValue = (
  value: string,
  countries: PhoneCountry[],
): PhoneCountry | undefined => {
  const digitsOnly = value?.replace(/\D/g, "");

  if (!digitsOnly) {
    return undefined;
  }

  // Специальная логика для +7 (России/Казахстана)
  if (digitsOnly.startsWith("7") && digitsOnly.length >= 4) {
    const prefix = digitsOnly.substring(1, 4); // три цифры после +7

    const firstDigit = prefix[0];

    if (firstDigit === "6" || firstDigit === "7") {
      return countries.find((c) => c.isoCode === "KZ");
    }
    if (["3", "4", "8", "9"].includes(firstDigit)) {
      return countries.find((c) => c.isoCode === "RU");
    }
    return undefined;
  }

  // Стандартное определение по коду страны
  return countries.find((country) => {
    const dialCodeDigits = country.dialCode.replace(/\D/g, "");
    return digitsOnly.startsWith(dialCodeDigits);
  });
};
